import React                           from 'react';
import {
  Form,
  Field,
  Formik,
  FormikProps,
}                                      from 'formik';
import styled, {
  css,
  Interpolation,
}                                      from 'styled-components';
import { Grid }                        from '@material-ui/core';
import { IResetPasswordInitialValues } from '@typings/auth';
import { Button, TextInput }           from '@components/index';

interface IProps {
  initialValues       : IResetPasswordInitialValues;
  validationSchema    : object;
  handleResetPassword : (values: IResetPasswordInitialValues) => void;
  isUpdateBidderPass? : boolean;
  isPasswordResetting : boolean;
}

interface IStyledProps {
  isUpdateBidderPass: boolean;
}

const Wrapper = styled.div`
  width: 300px;
`;

const TitleWrapper = styled.div`
  font-size     : ${({ isUpdateBidderPass }: IStyledProps): string => (isUpdateBidderPass ? '20px' : '28px')};
  font-weight   : 500;
  color         : ${({ theme: { textColor } }): string => textColor.secondary};

  ${({ isUpdateBidderPass }: IStyledProps): Interpolation<IStyledProps> => isUpdateBidderPass && css`
    margin-block: 10px;
  `}
`;

const InputWrapper = styled.div`
  position: relative;
`;

const LabelWrapper = styled.p`
  position      : absolute;
  left          : -210px;
  top           : 20px;
  width         : 200px;
  padding-right : 10px;
  font-size     : ${({ isUpdateBidderPass }: IStyledProps): string => (isUpdateBidderPass ? '16px' : '18px')};
  font-weight   : ${({ isUpdateBidderPass }: IStyledProps): Interpolation<IStyledProps> => !isUpdateBidderPass && 500};
  text-align    : right;
  color         : ${({ theme: { textColor } }): string => textColor.black};
`;

const HintWrapper = styled.div`
  font-size   : 16px;
  font-weight : bold;
  padding     : 10px 0;
  text-align  : center;
  color       : ${({ theme: { textColor } }): string => textColor.gray};
`;

const StyledInput = styled(TextInput)`
  && input {
    font-weight      : 400;
    font-size        : 16px;
    height           : 35px;
    background-color : ${({ theme: { backgroundColor } }): string => backgroundColor.white};
    color            : ${({ theme: { textColor } }): string => textColor.gray} !important;
  }
`as any;

export const ResetPassword: React.FC<IProps> = ({
  initialValues,
  validationSchema,
  handleResetPassword,
  isUpdateBidderPass = false,
  isPasswordResetting,
}: IProps): JSX.Element => (
  <Formik
    onSubmit         = {handleResetPassword}
    initialValues    = {initialValues}
    validationSchema = {validationSchema}
    validateOnMount
  >
    {({
      dirty,
      isValid,
    }:FormikProps<IResetPasswordInitialValues>): JSX.Element => (
      <Form>
        <Wrapper>
          <Grid container spacing={2} justify="center">
            <Grid item xs={12}>
              <TitleWrapper isUpdateBidderPass={isUpdateBidderPass}>
                {isUpdateBidderPass ? 'Update Password' : 'Password Reset'}
              </TitleWrapper>
            </Grid>

            <Grid item xs={12}>
              <InputWrapper>
                <LabelWrapper isUpdateBidderPass={isUpdateBidderPass}>
                  Password
                </LabelWrapper>
                <Field
                  id          = "newPassword"
                  name        = "newPassword"
                  type        = "password"
                  placeholder = "8-32 characters password"
                  component   = {StyledInput}
                />
              </InputWrapper>
            </Grid>

            <Grid item xs={12}>
              <InputWrapper>
                <LabelWrapper isUpdateBidderPass={isUpdateBidderPass}>
                  Confirm Password
                </LabelWrapper>
                <Field
                  id          = "confirmPassword"
                  name        = "confirmPassword"
                  type        = "password"
                  placeholder = "Confirm password"
                  component   = {StyledInput}
                />
              </InputWrapper>
            </Grid>

            <Grid item xs={12}>
              <HintWrapper>
                Please enter and confirm a new password
              </HintWrapper>
            </Grid>

            <Grid item xs={12}>
              <Button
                type      = "submit"
                label     = "Save Changes"
                margin    = "0"
                isLoading = {isPasswordResetting}
                disabled  = {!isValid || !dirty || isPasswordResetting}
                fullWidth
              />
            </Grid>
          </Grid>
        </Wrapper>
      </Form>
    )}
  </Formik>
);
